import {
  Checkbox,
  KoDate,
  KoForm,
  KoFormBuilder,
  KoImage,
  KoLoader,
  KoSelect,
  KoText,
  KoTextArea,
  KoToast,
  KoUserSelect,
  Upload
} from 'packages';
import KoIcon from '@kwapio/icons';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './crud.module.scss';
import ItemEntryCrud from './itemEntryCrud';
import { EVENT_PLANNING_TYPES, EVENT_WORKFLOW } from './constant';
import ImgCrop from 'antd-img-crop';
// import { generateAllTimes, generateEndTimes } from 'shared/utils';
import { EventsAPI } from './events.service';
import { getCookie } from 'shared/utils/cookies';
// const optionGroups = [
//   { label: 'Zoom', value: 'zoom' },
//   { label: 'Microsoft Teams', value: 'teams' },
//   { label: 'Google Meet', value: 'gmeet' }
// ];

const DurationValues = [
  { label: '15 Mins', value: '15m' },
  { label: '30 Mins', value: '30m' },
  { label: '45 Mins', value: '45m' },
  { label: '1 Hour', value: '1h' },
  { label: '1.5 Hour', value: '1.5h' },
  { label: '2 Hour', value: '2h' },
  { label: '2.5 Hour', value: '2.5h' },
  { label: '3 Hour', value: '3h' },
  { label: '3.5 Hour', value: '3.5h' },
  { label: '4 Hour', value: '4h' },
  { label: '4.5 Hour', value: '4.5h' },
  { label: '5 Hour', value: '5h' },
  { label: '5.5 Hour', value: '5.5h' },
  { label: '6 Hour', value: '6h' },
  { label: '6.5 Hour', value: '6.5h' }
];

const RecurrenceValues = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekdays Only (Mon–Fri)', value: 'weekday' },
  { label: 'Weekly (Same Day)', value: 'weekly' },
  { label: 'Weekends Only (Sat–Sun)', value: 'weekends' },
  { label: 'Monthly (Same Date)', value: 'monthly' }
];

const OneValues = [
  { label: '1-on-1 Meeting', value: '1' },
  { label: 'Group Meeting', value: '2' }
];


const yesNOs = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
];


function EventCrud({ form, handleFinish, initialValues, eventId }) {
  const users = useSelector(state => state?.users?.data || []);
  const groups = useSelector(state => state?.groups?.data || []);
  const orgWatch = KoForm.useWatch('isOrganization', form);
  const eventTypeWatch = KoForm.useWatch('eventType', form);
  const isPaidWatch = KoForm.useWatch('isPaid', form);
  const [isLoading, setLoading] = useState(false);
  const localLogo = KoForm.useWatch('logo', form);
  useEffect(() => {
    if (!initialValues || Object.keys(initialValues).length === 0) {
      form.resetFields();
    } else {
      initialValues['organizer'] = getCookie('userId');
      const current = form.getFieldsValue();

      const normalizedValues = {
        ...initialValues,
        assignees: Array.isArray(initialValues.assignees)
          ? initialValues.assignees.map((a) =>
            typeof a === 'string' ? a : a.userId
          )
          : [],

        groups: Array.isArray(initialValues.groups)
          ? initialValues.groups.map((a) =>
            typeof a === 'string' ? a : a.groupId
          )
          : []

      };

      const changed = Object.entries(normalizedValues).some(
        ([key, val]) => current[key] !== val
      );

      if (changed) {
        form.setFieldsValue(normalizedValues);
      }
    }
  }, [initialValues, form]);



  const handleSubmit = useCallback(values => {
    handleFinish(values);
  });

  const Groups = ({ value, onChange }) => (
    <KoSelect
      mode="multiple"
      showSearch
      allowClear
      value={value}
      onChange={onChange}
      placeholder='Choose groups'
      options={groups.map(group => ({ label: group.name, value: group.groupId }))}
    />
  );


  const Assignees = ({ value, onChange }) => (
    <KoUserSelect users={users} value={value} onChange={onChange} placeholder='Select assignees' mode="multiple" />
  );

  const Organizer= ({ value, onChange }) => (
    <KoUserSelect users={users} value={value} onChange={onChange} placeholder='Select organizer' />
  );

  const ItemTable = () => <ItemEntryCrud form={form} handleFinish={handleFinish} initialValues={initialValues} />;

  // const EventVia = ({ value, onChange }) => (
  //   <KoSelect
  //     allowClear
  //     showSearch
  //     value={value}
  //     onChange={v => onChange(v)}
  //     className={styles.dropdown}
  //     placeholder="Select meeting platform"
  //     options={optionGroups}
  //     optionRender={option => (
  //       <div className={styles.iconWithLabel} role="img" aria-label={option.data.label}>
  //         {option.data.value === 'zoom' && <KoIcon name="ZoomFilled" />}
  //         {option.data.value === 'teams' && <KoIcon name="MicrosoftTeamsFilled" />}
  //         {option.data.value === 'gmeet' && <KoIcon name="GoogleMeetFilled" />}
  //         {option.data.label}
  //       </div>
  //     )}
  //   />
  // );


  const Duration = ({ value, onChange }) => {
    return (
      <KoSelect
        value={value}
        onChange={v => onChange(v)}
        showSearch
        allowClear
        placeholder='Choose duration'
        options={DurationValues?.map((value) => ({
          label: value.label,
          value: value?.value
        }))}
      />
    );
  };



  const Recurrence = ({ value, onChange }) =>

    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Choose recurrence'
      options={RecurrenceValues?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;


  const EventType = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Choose Event Type'
      options={OneValues?.map((option) => ({
        label: option.label,
        value: option?.value
      }))}
    />;

  const YESNO = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Choose Option'
      options={yesNOs?.map((option) => ({
        label: option.label,
        value: option?.value
      }))}
    />;

  const ActivityType = ({ value, onChange }) => (
    <KoSelect
      value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder="Select activity type"
      options={EVENT_PLANNING_TYPES}
      optionRender={(option) => (
        <div className={styles.iconWithLabel} role="img" aria-label={option.data?.label}>
          <KoIcon name={option.data?.icon} />
          {option.data?.label}
        </div>
      )}
    />
  );

  const StatusType = ({ value, onChange }) => (
    <KoSelect
      value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder="Select status"
      options={EVENT_WORKFLOW}
      optionRender={(option) => {
        const label = option?.data?.label;
        const formattedLabel = typeof label === 'string' ? label.replace(" ", '') : '';
        return (
          <div className={styles.statusWrapper} >
            <div style={{ backgroundColor: option?.data?.color }} className={`${styles.status} ${styles[formattedLabel]}`} role="img" aria-label={label} />
            <KoText style={{ color: option?.data?.color }} text={label} />
          </div>
        );
      }}
    />
  );

  const StartDate = ({ value, onChange }) => (
    <KoDate
      value={value}
      format={'DD-MMM-YYYY'}
      onChange={onChange}
    />
  );

  const EndDate = ({ value, onChange }) => (
    <KoDate
      value={value}
      format={'DD-MMM-YYYY'}
      onChange={onChange}
    />
  );

  const TextArea = ({ value, onChange }) => (
    <KoTextArea value={value} onChange={onChange} showCount
      maxLength={100}/>
  );

  // const allTimes = generateAllTimes();

  // const StarTime = ({ value, onChange }) => (
  //   <KoSelect
  //     value={value}
  //     onChange={onChange}
  //     showSearch
  //     allowClear
  //     placeholder='Choose Start Time'
  //     options={allTimes}
  //   />
  // );

  // const EndTime = ({ value, onChange }) => (
  //   <KoSelect
  //     value={value}
  //     onChange={onChange}
  //     showSearch
  //     allowClear
  //     placeholder='Choose End Time'
  //     disabled={!startTimeWatch}
  //     options={generateEndTimes(startTimeWatch)}
  //   />
  // );

  const meta = {
    columns: 6,
    formItemLayout: null,
    initialValues: {
      name: '',
      activityTypes: 1,
      status: 1,
      approverComments: '',
      duration: '1h',
      email: [],
      startDate: null,
      endDate: null,
      eventVia: 'zoom',
      reoccurrence: null,
      eventType: '1',
      location: '',
      isPaid: false,
      amount: undefined,
      description: '',
      permissions: [],
      membersCount: undefined,
      assignees: [],
      groups: []
    },
    colon: true,
    fields: [
      { key: 'name', label: 'Meeting Name', placeholder: 'Enter event name', colSpan: 4, rules: [{ required: true, message: 'Enter event name' }] },
      { key: 'activityTypes', label: 'Activity Type', widget: ActivityType, colSpan: 1, rules: [{ required: true, message: 'Select activity type' }] },
      { key: 'status', label: 'Status', widget: StatusType, colSpan: 1, rules: [{ required: true, message: 'Select status' }] },
      { key: 'assignees', label: 'Team members', colSpan: 2, widget: Assignees },
      { key: 'organizer', label: 'Organizer', colSpan: 2, widget: Organizer },
      { key: 'duration', label: 'Duration', colSpan: 2, widget: Duration, rules: [{ required: true, message: 'Select duration' }] },
      { key: 'startDate', label: 'Start Date', colSpan: 2, widget: StartDate, rules: [{ required: true }] },
      { key: 'endDate', label: 'End Date', colSpan: 2, widget: EndDate, rules: [{ required: true, message: 'Select meeting platform' }] },
      // { key: 'eventVia', label: 'Meeting via', colSpan: 2, widget: EventVia, rules: [{ required: true, message: 'Select meeting platform' }] },
      { key: 'reoccurrence', label: 'Recurrence', colSpan: 1, widget: Recurrence },
      { key: 'isAutoAccept', label: 'Auto Accept?', widget: YESNO, colSpan: 1 },
      { key: 'eventType', label: 'Engagement Type', colSpan: 2, widget: EventType },
      { key: 'location', label: 'Location (if physical)', placeholder: 'Enter venue or meeting room', colSpan: 2 },
      { key: 'isPaid', label: 'Is Paid Event?', widget: YESNO, colSpan: 1 },
      ...(isPaidWatch ? [{ key: 'amount', label: 'Amount (₹)', placeholder: 'Enter fee amount', type: 'number', colSpan: 1, rules: [{ required: true, message: 'Enter amount' }] }] : []),
      { key: 'description', label: 'Instruction / Description / Notes', placeholder: 'Enter description or notes', colSpan: 6, widget: TextArea},
      {
        key: 'permissions', label: 'Attendees Permission', colSpan: 4, widget: Checkbox.Group, options: [
          { label: 'Modify Meeting', value: 'modify_events' },
          { label: 'Invite Others', value: 'invite_others' },
          { label: 'Attendees List', value: 'attendees_list' }
        ]
      },
      { key: '', label: 'Agenda', colSpan: 6, widget: ItemTable }
    ]
  };

  if (orgWatch) {
    meta.fields.splice(2, 1, { key: 'assignees', label: 'Assignees', colSpan: 2, widget: Assignees });
    meta.fields.splice(3, 0, { key: 'groups', label: 'Groups', colSpan: 2, widget: Groups });
  }

  if (eventTypeWatch === '2') {
    meta.fields.splice(orgWatch ? 11 : 10, 0, { key: 'membersCount', label: 'How many members', colSpan: 2, type: 'number' });
  }

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }

    return e?.fileList;
  };


  const props = {
    name: 'files',
    multiple: false,
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data: { module: 'engagements', lookupId: eventId },
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },
    onChange(info) {
      setLoading(true);
      if (info.file.status !== 'uploading') {
      }
      const { fileList } = info;

      // Check if all uploads have either completed or failed
      const allFinished = fileList.every(
        file => file.status === 'done' || file.status === 'error'
      );

      if (allFinished) {
        setLoading(true);

        const successfulFiles = fileList
          .filter(file => file.status === 'done')
          .map(file => ({
            name: file.name,
            type: file.type,
            size: file.size,
            uid: file.uid,
            url: file.url || file.response[0],
            lastModifiedDate: file.lastModifiedDate || new Date().toISOString()
          }));

        form.setFieldsValue({ logo: successfulFiles });
        setLoading(false);
      }
      else if (info.file.status === 'done') {
        KoToast.success(`${info.file.name} file uploaded successfully`);
        setLoading(false);
      }
      else if (info.file.status === 'error') {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      KoToast.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      KoToast.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };

  const uploadButton = (
    <div className={styles.dndArea}>
      {!initialValues?.logo ? <>
        <KoIcon name='ImagesOutlined' />
        {isLoading && <KoLoader size='small' />}
        <KoText className={styles.fileInfo} text='At least 256 x 256px PNG or JPG file' />
      </> :
        (initialValues?.logo?.length > 0 || localLogo.length > 0) && <KoImage preview={false} src={localLogo?.length > 0 ? localLogo[0].url : initialValues?.logo[0].url  } />}
    </div>
  );

  const onRemoveFile = (d) => {
    let obj = {
      path: `${getCookie('wos')}/taskplanner/${initialValues?.lookupId}/`,
      files: [d?.uid]
    };
    EventsAPI.deleteAttachments(obj).then(
      (data) => {
      },
      (err) => {
      }
    );
  };

  return (
    <div className={styles.modalWrapper}>
      <KoForm form={form} layout="vertical" onFinish={handleSubmit}>
        <KoForm.Item
          name={["logo"]}
          valuePropName={["logo"]}
          getValueFromEvent={normFile}

        >
          <ImgCrop aspect={4/1}
            quality={0.8}        >
            <Upload {...props}
              className={styles.upload}
              beforeUpload={beforeUpload}
              onRemove={onRemoveFile}
              max={{ count: 1 }}
              showUploadList={false}
              showPreviewIcon={false}
              listType="picture-card"
            >
              {uploadButton}
            </Upload>
          </ImgCrop>
        </KoForm.Item>
        <KoFormBuilder form={form} meta={meta} />
      </KoForm>
    </div>
  );
}

export default EventCrud;
